import PropTypes from 'prop-types';
import React from 'react';

import ButtonLink from '../ButtonLink';

import {
  block,
  container,
  content,
  flex,
  heading,
  homepageContainer,
  homepageContent,
  homepageHeading,
  link,
  right,
  text as textStyle,
} from './styles.module.css';

const SignUpPrompt = ({
  buttonText,
  homepage,
  title,
  text,
}) => (
  <div className={homepage ? homepageContainer : container}>
    <div className={homepage ? homepageContent : content}>
      <h3 className={homepage ? homepageHeading : heading}>{title}</h3>
      <span className={textStyle}>
        {text}
      </span>
    </div>
    <div className={homepage ? block : flex}>
      <ButtonLink
        to="/login"
        className={homepage ? link : right}
        primary
        data-tracking-link="signup-button"
        data-tracking-type={homepage ? 'homepage-prompt' : 'event-list-prompt'}
      >
        {buttonText}
      </ButtonLink>
    </div>
  </div>
);

export default SignUpPrompt;

SignUpPrompt.propTypes = {
  /*
   * String to allow dynamic discipline strings in sentence.
   * E.g. 'Access Excusive _Running_ events'.
   */
  buttonText: PropTypes.string,
  /*
   * Bool to determine whether component is being rendered on homepage
   * Inherits different styles if so.
   */
  homepage: PropTypes.bool,
  /*
   * Paragraph text for component.
   */
  text: PropTypes.string,
  /*
   * Title/heading of the component.
   */
  title: PropTypes.string,
};

SignUpPrompt.defaultProps = {
  buttonText: 'Let’s Do This',
  homepage: false,
  text: '',
  title: '',
};
